<template>
  <el-dialog
    :lock-scroll="false"
    :visible.sync="dialogVisible"
    @close="onCancleBtn"
    :close-on-click-modal="false"
    title="添加/修改"
  >
    <el-form
      ref="addOrEditForm"
      label-width="100px"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <!-- <el-form-item label="活动类型" prop="activityType">
        <el-select v-model="form.activityType" placeholder="请选择活动类型" style="width: 100%">
          <el-option label="常规" value="common"></el-option>
          <el-option label="新用户注册" value="new_user"></el-option>
        </el-select>
      </el-form-item> -->
      <section class="time-group">
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            type="datetime"
            v-model="form.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
      </section>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="form.remark"></el-input>
      </el-form-item>
      <section class="active-detail">
        <h6>活动详情</h6>
        <ul class="active-detail-list">
          <li v-for="(item, index) in detailList" :key="index">
            <dl>
              <dt>充值金额:</dt>
              <dd><el-input v-model="item.rechargeAmount"></el-input></dd>
            </dl>
            <dl>
              <dt>赠送金额:</dt>
              <dd><el-input v-model="item.giftAmount"></el-input></dd>
            </dl>
            <!-- <dl>
              <dt>农行赠送:</dt>
              <dd><el-input v-model="item.abcGiftAmount"></el-input></dd>
            </dl> -->
            <i class="el-icon-delete" @click="delOne(index)"></i>
          </li>
        </ul>
        <section class="add-icon">
          <i class="el-icon-circle-plus-outline" @click="addOne"></i>
        </section>
      </section>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addOrEditTrue">确定</el-button>
      <el-button @click="onCancleBtn">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updateOneRechargeConfiguration } from "@/api/url.js";
export default {
  props: {
    oneDetail: {
      default: null,
      type: Object,
    },
  },
  data() {
    const checkTime = (rule, value, callback) => {
      if (this.form.startTime && this.form.endTime) {
        const differTime =
          new Date(this.form.startTime).getTime() -
          new Date(this.form.endTime).getTime();
        if (differTime >= 0) {
          callback("开始时间大于结束时间");
        } else {
          callback();
        }
      }
    };
    return {
      dialogVisible: true,
      detailList: [],
      form: {},
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        activityType: [{ required: true, message: "请选择活动类型", trigger: "change" }],
        startTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: ["blur", "change"],
          },
          { validator: checkTime, trigger: ["blur", "change"] },
        ],
        endTime: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: ["blur", "change"],
          },
          { validator: checkTime, trigger: ["blur", "change"] },
        ],
      },
    };
  },
  created() {
    this.initDetails();
  },
  methods: {
    onCancleBtn() {
      this.$emit("func", "cancle");
    },
    addOrEditTrue() {
      const { id } = this.form;
      this.$refs.addOrEditForm.validate((vali) => {
        if (vali) {
          // 合并 name 和 activityType，用逗号隔开
          const submitData = {
            ...this.form,
            // name: `${this.form.name},${this.form.activityType}`,
            activityItems: this.detailList,
            type: "recharge",
          };
          // delete submitData.activityType;
          if (id) {
            this.$putRequest(`${updateOneRechargeConfiguration()}/${id}`, submitData).then((res) => {
              const { status, message } = res;
              if (status === 200) {
                this.$emit("func", "edit");
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
              } else {
                this.$message({
                  type: "warning",
                  message,
                });
              }
            });
          } else {
            this.$postRequest(updateOneRechargeConfiguration(), submitData).then((res) => {
              const { status, message } = res;
              if (status === 200) {
                this.$emit("func", "add");
                this.$message({
                  type: "success",
                  message: "添加成功",
                });
              } else {
                this.$message({
                  type: "warning",
                  message,
                });
              }
            });
          }
        }
      });
    },
    delOne(index) {
      this.detailList.splice(index, 1);
    },
    addOne() {
      this.detailList.push({
        rechargeAmount: "0.00",
        giftAmount: "0.00",
        abcGiftAmount: "0.00",
      });
    },
    initDetails() {
      if (this.oneDetail) {
        const {
          id,
          name,
          startTime,
          endTime,
          activityItems,
          remark,
          activityType,
        } = this.oneDetail;
        // 如果 name 中包含逗号，说明是合并后的格式，需要拆分
        let formName = name;
        let formActivityType = activityType || "common";
        if (name && name.includes(",")) {
          const parts = name.split(",");
          formName = parts[0];
          formActivityType = parts[1] || "common";
        }
        this.form = {
          id,
          name: formName,
          startTime,
          endTime,
          remark,
          activityType: formActivityType,
        };
        this.detailList = JSON.parse(JSON.stringify(activityItems));
      } else {
        this.form = {
          activityType: "common",
        };
        this.detailList = [
          { rechargeAmount: "0.00", giftAmount: "0.00", abcGiftAmount: "0.00" },
        ];
      }
    },
  },
};
</script>
<style scoped lang="scss">
.time-group {
  display: flex;
  justify-content: space-between;
  .el-form-item {
    width: 50%;
    .el-date-editor.el-input {
      width: 100%;
      max-width: 100%;
    }
  }
}
.active-detail {
  border: 1px dashed #eee;
  border-radius: 10px;
  margin: 10px;
  box-sizing: border-box;
  padding: 20px;
  h6 {
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
  .active-detail-list {
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding-bottom: 10px;
      margin-bottom: 10px;
      &:not(:last-child) {
        border-bottom: 1px dashed #eee;
      }
      dl {
        width: 30%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        dt {
          width: 100px;
          font-weight: normal;
          color: #606266;
          font-size: 14px;
        }
      }
    }
  }
}

.el-icon-delete {
  font-size: 20px;
  color: #409eff;
  cursor: pointer;
}
.add-icon {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  .el-icon-circle-plus-outline {
    font-size: 40px;
    color: #409eff;
    cursor: pointer;
  }
}
</style>
